import { createRouter, createWebHistory } from "vue-router";
import Home from "../views/Home.vue";
import About from "../views/About.vue";
import Shows from "@/views/Shows.vue";
import Classes from "../views/Classes.vue";
import Visit from "../views/Visit.vue";
import Company from "../views/Company.vue";
import HireUs from "../views/HireUs.vue";
import Contact from "@/views/Contact.vue";
import Subscribe from "@/views/Subscribe.vue";
import TheCut from "@/views/TheCut.vue";
import Endurance from "@/views/Endurance.vue";
import Unsubscribe from "@/views/Unsubscribe.vue";
import NotFound from "@/views/NotFound.vue";
import News from "@/views/News.vue";
import NewsDetail from "@/views/NewsDetail.vue";
import Jam from "@/views/Jam.vue";
import BOM from "@/views/BOM.vue";

const routes = [
  // Redirect /shows.php to /shows
  {
    path: "/shows.php",
    redirect: "/shows"
  },
  // Redirect /press to /contact
  {
    path: "/press",
    redirect: "/contact"
  },
  {
    path: "/",
    name: "Home",
    component: Home,
    meta: {
      title: "Atlas Improv – Madison's Only Dedicated Improv Stage",
      description: "Madison's only dedicated improv stage. Live, character-driven comedy every Friday and Saturday night at 7 & 9 PM, plus year-round classes that take you from your first short scene to performance-ready long-form.",
      navBgColor: '#E35B4B'
    }
  },
  {
    path: "/thecut",
    name: "TheCut",
    component: TheCut,
    meta: {
      title: "Atlas Improv – The Cut",
      description: "The Cut is Atlas Improv's annual amateur tournament. Local improvisers battle for the ultimate prize — a spot on the professional roster at Madison's only dedicated improv stage.",
      navBgColor: '#FFFFFF',
      navInverse: true
    }
  },
  {
    path: "/endurance",
    name: "Endurance",
    component: Endurance,
    meta: {
      title: "Atlas Improv – Endurance",
      description: "Endurance is Atlas Improv's wildest experiment in long-form storytelling — improvised episodic seasons, performed live at Madison's only dedicated improv stage.",
      navBgColor: '#FFFFFF',
      navInverse: true
    }
  },
  {
    path: "/about",
    name: "About",
    component: About,
    meta: {
      title: "Atlas Improv – About Us",
      description: "Atlas Improv Co. has been Madison's home for character-driven improv comedy since 2004 — and is the city's only dedicated improv stage. Meet the company, learn the philosophy, see the space.",
      navBgColor: '#E35B4B'
    }
  },
  {
    path: "/shows",
    name: "shows",
    component: Shows,
    meta: {
      title: "Atlas Improv – Improv Comedy Shows in Madison, WI",
      description: "Catch live improv comedy at Madison's only dedicated improv stage. Two shows every Friday and Saturday night — Theatresports, Double Feature, the Long-Form Showcase, and themed nights like Trash TV.",
      navBgColor: '#FFFFFF'
    }
  },
  {
    path: "/classes",
    name: "classes",
    component: Classes,
    meta: {
      title: "Atlas Improv – Improv Classes in Madison, WI",
      description: "Find your fun on stage. Atlas Improv classes in Madison teach character-based storytelling, listening, and quick thinking — from your first Core Class through advanced long-form, all at Madison's only dedicated improv stage.",
      navBgColor: '#FFFFFF'
    }
  },
  {
    path: "/Subscribe",
    name: "subscribe",
    component: Subscribe,
    meta: {
      title: "Atlas Improv – Subscribe",
      description: "Subscribe to updates from Atlas Improv Co., Madison's only dedicated improv stage. Roughly one email a month about shows, themed nights, and class registrations.",
      navBgColor: '#FFFFFF'
    }
  },
  {
    path: "/Unsubscribe",
    name: "unsubscribe",
    component: Unsubscribe,
    meta: {
      title: "Atlas Improv – Unsubscribe",
      description: "Unsubscribe from Atlas Improv Co. updates.",
      navBgColor: '#FFFFFF'
    }
  },
  {
    path: "/visit",
    name: "visit",
    component: Visit,
    meta: {
      title: "Atlas Improv – Visit Us in Madison",
      description: "Plan your visit to Atlas Improv at 609 E Washington Ave — Madison's only dedicated improv stage. Tickets, parking, and what to expect on a Friday or Saturday night.",
      navBgColor: '#FFFFFF'
    }
  },
  {
    path: "/company",
    name: "company",
    component: Company,
    meta: {
      title: "Atlas Improv – The Company",
      description: "Meet the performers, teachers, and creators behind Madison's only dedicated improv stage.",
      navBgColor: '#39A5BF'
    }
  },
  {
    path: "/hireus",
    name: "hireus",
    component: HireUs,
    meta: {
      title: "Atlas Improv – Hire Us for Your Event",
      description: "Hire Atlas Improv — Madison's only dedicated improv stage — for corporate trainings, team-building events, custom shows, or to host your private event in our intimate downtown space.",
      navBgColor: '#FFFFFF'
    }
  },
  {
    path: "/contact",
    name: "Contact",
    component: Contact,
    meta: {
      title: "Atlas Improv – Contact",
      description: "Get in touch with Atlas Improv Co., Madison's only dedicated improv stage. Located at 609 E Washington Ave. Call or text (608) 216-5533, or email info@atlasimprov.com.",
      navBgColor: '#FFFFFF'
    }
  },
  {
    path: "/news",
    name: "News",
    component: News,
    meta: {
      title: "Atlas Improv – News & Announcements",
      description: "News, announcements, and behind-the-scenes from Atlas Improv Co. — Madison's only dedicated improv stage.",
      navBgColor: '#FFFFFF'
    }
  },
  {
    path: "/news/:slug",
    name: "NewsDetail",
    component: NewsDetail,
    meta: {
      title: "Atlas Improv – News",
      description: "News and stories from Atlas Improv Co., Madison's only dedicated improv stage.",
      navBgColor: '#FFFFFF'
    }
  },
  {
    path: "/jam",
    name: "Jam",
    component: Jam,
    meta: {
      title: "Atlas Improv – Open Improv Jams in Madison",
      description: "Open jams at Atlas Improv — Madison's only dedicated improv stage. Show up, sign up, and play. Up All Night Jam, Long-Form Jam, and more.",
      navBgColor: '#BB4A8C'
    }
  },
  {
    path: "/bom",
    name: "BOM",
    component: BOM,
    meta: {
      title: "Atlas Improv – Vote for Best of Madison 2026",
      description: "Atlas Improv Co. is the only improv group nominated in four categories in Madison Magazine's Best of Madison 2026 — Comedy Group, Performing Arts Group, Local Theater, and Best Place for a First Date. Vote for Madison's only dedicated improv stage!",
      navBgColor: '#E35B4B'
    }
  },
  {
    path: "/:pathMatch(.*)*",
    redirect: "/notfound"
  },
  {
    path: "/notfound",
    name: "NotFound",
    component: NotFound,
    meta: {
      title: "Atlas Improv – Page Not Found",
      description: "The page you are looking for was not found. Head back to Atlas Improv Co., Madison's only dedicated improv stage.",
      navBgColor: '#FFFFFF'
    }
  },
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
  scrollBehavior() {
    return new Promise(resolve => {
      setTimeout(() => resolve({ top: 0, behavior: 'instant' }), 150);
    });
  }
});

router.afterEach((to) => {
  if (to.hash) return;
  setTimeout(() => {
    document.documentElement.scrollTop = 0;
    document.body.scrollTop = 0;
  }, 150);
  if (typeof window.gtag === 'function') {
    window.gtag('event', 'page_view', {
      page_path: to.fullPath,
      page_title: to.meta.title || document.title,
    });
  }
});

export default router;
